// How a contract is shown to users. Its number (contracts.co) is called "CO" in every text (CO_LABEL,
// customer feedback 15) - the one place to change it - and a contract is shown as
// "35532453 – TESTNYFLOW (2026)". The database and API names (contracts.co, trials.PO) stay as they are,
// and contracts.id is an internal key: never show it.

export const CO_LABEL = 'CO';

/** "2958 – Eff FUNG Raspberries (2021)"; '' without a contract. */
export function coLabel(contract) {
  if (!contract) return '';
  const description = contract.description && String(contract.description).trim();
  return `${contract.co ?? '?'}${description ? ` – ${description}` : ''}${contract.year ? ` (${contract.year})` : ''}`;
}

/** Contracts newest year first, then by CO number (newest first), for pick lists. */
export function sortContracts(contracts = []) {
  return [...contracts].sort((a, b) => (b.year || 0) - (a.year || 0) || (Number(b.co) || 0) - (Number(a.co) || 0));
}
